// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".io-headline{position:relative;z-index:2;display:block;margin:0;text-align:var(--base-text-align)}", ""]);
// Exports
module.exports = exports;
